const $ = window.jQuery;
import _ from 'lodash';

$(() => {
    const $searchBars = $('.collections-search__form');

    if (!$searchBars.length) {
        return;
    }

    _.each($searchBars, searchBar => {
        const $searchBar = $(searchBar);
        const baseUrl = $searchBar.data('url');

        $($searchBar).on('submit', e => {
            e.preventDefault();
            const target = e.target;
            const inputValue = $(target)
                .find('.collections-search__bar')
                .val();

            if (inputValue.length) {
                // Not finalized logic here, need to work out actual
                // Search destination
                const searchUrl = `${baseUrl}/search?q=${inputValue}`;
                window.open(searchUrl);
            }
        });
    });
});
